module.exports = __webpack_public_path__ + "img/location.90798f0e.svg";